// extracted by mini-css-extract-plugin
module.exports = {"boxStyle":"Skills_boxStyle__3E7j1","rightBox":"Skills_rightBox__1eq1D","iconBox":"Skills_iconBox__1nrfF","img":"Skills_img__cqiEw","skillsTitle":"Skills_skillsTitle__3sUay"};